Drupal.behaviors.sw_section_testimonials = {
  attach: function( context, settings ) {

    $('.testimonials').once('sw_section_testimonials').each(function() {
      let $wrap = $(this);
      let $slider = $wrap.find('.testimonials__slider');
      $slider.slick({
        arrows: true,
        fade: false,
        dots: false,
        adaptiveHeight: false,
        infinite: true,
        centerMode: true,
        //slidesToShow: 1,
        waitForAnimate: false,
      });

    });

  }
};
